import classNames from 'classnames';
import * as React from 'react';
import { IInputProps } from '../Input/Input';
import './style.scss';

interface IProps extends IInputProps {
  wrapperClassName?: string;
}

export default class InputApi extends React.Component<IProps, {}> {
  input: React.RefObject<HTMLInputElement> = React.createRef();
  static defaultProps = {
    wrapperClassName: '',
  };

  focus = () => this.input.current?.focus();

  public render() {
    const { wrapperClassName, error, ...props } = this.props;
    return (
      <div dir="ltr" className={classNames('input-domain full-width', wrapperClassName, { 'input-error': error })}>
        <p onClick={this.focus} className="input-prefix family-medium text-size-18 d-flex align-items-center">
          https://
        </p>
        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
        <input ref={this.input} {...props} />
      </div>
    );
  }
}
